import React from 'react'
import { View } from 'react-native'
import moment from 'moment'
import { MONTH_NAME_AND_DATE_WITH_YEAR_FORMAT } from '@config/momentFormat'
import { StyleService, useStyleSheet } from '@style/service'
import { Text } from '@components/base'
import { ChatbotConversation } from '@src/types'
import { ConversationTag } from './ConversationTag'

export const ConversationTitle = ({ conversation }: { conversation: ChatbotConversation }) => {
  const styles = useStyleSheet(themedStyle)
  const date = moment(conversation.createdAt).format(MONTH_NAME_AND_DATE_WITH_YEAR_FORMAT)

  return (
    <View style={styles.container}>
      <Text type="large" bold numberOfLines={1}>
        {conversation.title}
      </Text>
      <View style={styles.row}>
        <Text type="small" style={styles.date}>
          {date}
        </Text>
        {conversation.tags.slice(0, 3).map((tag) => (
          <ConversationTag key={tag} tag={tag} />
        ))}
      </View>
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    flexShrink: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginTop: 2,
  },
  date: {
    color: 'theme.text.secondary',
    marginRight: 4,
  },
})
